import { render, staticRenderFns } from "./jinYiCi.vue?vue&type=template&id=023b04c4&scoped=true&"
import script from "./jinYiCi.vue?vue&type=script&lang=js&"
export * from "./jinYiCi.vue?vue&type=script&lang=js&"
import style0 from "./jinYiCi.vue?vue&type=style&index=0&id=023b04c4&prod&lang=scss&"
import style1 from "./jinYiCi.vue?vue&type=style&index=1&id=023b04c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b04c4",
  null
  
)

export default component.exports